<template>
    <div>
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-header d-flex justify-content-between align-items-center">
                        <h5 class="card-title mb-0">Current Employment Information</h5>
                    </div>
                    <div class="card-body">
                        <div class="row g-3 mb-2">
                            <div class="col-12">
                                <div class="row g-3">
                                    <div class="col-sm-6 col-md-4">
                                        <label class="small text-muted">Civil service</label>
                                        <h6 class="mb-0" v-if="employee.civil_service">{{ employee.civil_service.title
                                            }}</h6>
                                    </div>
                                    <div class="col-sm-6 col-md-4">
                                        <label class="small text-muted">MDA</label>
                                        <h6 class="mb-0" v-if="employee.ministry">{{ employee.ministry.name }}</h6>
                                    </div>
                                    <div class="col-sm-6 col-md-4">
                                        <label class="small text-muted">Department</label>
                                        <h6 class="mb-0" v-if="employee.department">{{ employee.department.name }}</h6>
                                    </div>
                                    <div class="col-sm-6 col-md-4">
                                        <label class="small text-muted">Salary structure</label>
                                        <h6 class="mb-0" v-if="employee.salary_structure">{{
                                            employee.salary_structure.title }}</h6>
                                    </div>
                                    <div class="col-sm-6 col-md-4">
                                        <label class="small text-muted">Grade level</label>
                                        <h6 class="mb-0" v-if="employee.grade_level">{{
                                            employee.grade_level.title }}</h6>
                                    </div>
                                    <div class="col-sm-6 col-md-4">
                                        <label class="small text-muted">Step Level</label>
                                        <h6 class="mb-0" v-if="employee.step_level">{{
                                            employee.step_level.title }}</h6>
                                    </div>
                                    <div class="col-sm-6 col-md-4">
                                        <label class="small text-muted">Rank</label>
                                        <h6 class="mb-0" v-if="employee.rank">{{ employee.rank.title }}</h6>
                                    </div>
                                    <div class="col-sm-6 col-md-4">
                                        <label class="small text-muted">Designation</label>
                                        <h6 class="mb-0" v-if="employee.designation">{{ employee.designation.title }}
                                        </h6>
                                    </div>
                                    <div class="col-sm-6 col-md-4">
                                        <label class="small text-muted">Former Employee number</label>
                                        <h6 class="mb-0">{{ employee.former_employee_number }}</h6>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row mb-4 g-4">
                    <div class="col-12">
                        <div class="card h-100 mb-0 shadow-sm">
                            <div class="card-header d-flex justify-content-between align-items-center">
                                <h5 class="card-title mb-0">First Entry Employment Info</h5>
                            </div>
                            <div class="card-body">
                                <div class="row g-4">
                                    <div class="col-sm-6 col-md-4">
                                        <label class="small text-muted">Employment number</label>
                                        <h6 class="mb-0">{{ employment.employment_number }}</h6>
                                    </div>
                                    <div class="col-sm-6 col-md-4">
                                        <label class="small text-muted">Date of appointment:</label>
                                        <h6 class="mb-0">{{ $filters.date(employment.appointment_date) }}</h6>
                                    </div>
                                    <div class="col-sm-6 col-md-4">
                                        <label class="small text-muted">Appointment type:</label>
                                        <h6 class="mb-0">{{ $filters.textFromSlug(employment.employment_type) }}</h6>
                                    </div>
                                     <div class="col-sm-6 col-md-4">
                                        <label class="small text-muted">Retirement date</label>
                                        <h6 class="mb-0">{{ $filters.date(employment.retirement_date) }}</h6>
                                    </div>
                                    <div class="col-sm-6 col-md-4">
                                        <label class="small text-muted">MDA:</label>
                                        <h6 v-if="employment.first_ministry" class="mb-0">{{
                                            employment.first_ministry.name }}</h6>
                                    </div>
                                    <div class="col-sm-6 col-md-4">
                                        <label class="small text-muted">Department:</label>
                                        <h6 v-if="employment.first_department" class="mb-0">{{
                                            employment.first_department.name }}</h6>
                                    </div>
                                    <div class="col-sm-6 col-md-4">
                                        <label class="small text-muted">Designation</label>
                                        <h6 class="mb-0" v-if="employment.designation">{{ employment.designation.title }}
                                        </h6>
                                    </div>
                                    <div class="col-sm-6 col-md-4">
                                        <label class="small text-muted">Rank</label>
                                        <h6 class="mb-0" v-if="employment.rank">{{ employment.rank.title }}</h6>
                                    </div>
                                    <div class="col-sm-6 col-md-4">
                                        <label class="small text-muted">Cadre</label>
                                        <h6 class="mb-0" v-if="employment.cadre">{{ employment.cadre.title }}</h6>
                                    </div>
                                    <div class="col-sm-6 col-md-4">
                                        <label class="small text-muted">Salary Structure:</label>
                                        <h6 v-if="employment.salary_structure" class="mb-0">{{
                                            employment.salary_structure.title }}</h6>
                                    </div>
                                    <div class="col-sm-6 col-md-4">
                                        <label class="small text-muted">Grade level:</label>
                                        <h6 v-if="employment.first_grade_level" class="mb-0">{{
                                            employment.first_grade_level.title }}</h6>
                                    </div>
                                    <div class="col-sm-6 col-md-4">
                                        <label class="small text-muted">Step level:</label>
                                        <h6 v-if="employment.first_step_level" class="mb-0">{{
                                            employment.first_step_level.title }}</h6>
                                    </div>
                                    <div class="col-sm-6 col-md-4">
                                        <label class="small text-muted">Appointment letter </label>
                                        <h6 v-if="employment.appointment_letter" class="mb-0">
                                            <button class="btn btn-link p-0 btn-sm"
                                                @click.prevent="showProfileImg(employment.appointment_letter)">View Appointment letter</button>
                                        </h6>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>

export default {
    props: {
        employee: {
            type: Object,
            required: true
        }
    },
    computed: {
        user() {
            return this.employee.user
        },
        employment() {
            return this.employee.employment || {}
        }
    }
}
</script>

<style></style>